class SignageDesign {
  store;
  id;
  screenId;
  version;
  name;
  components;
  settings;
  createdAt;
  updatedAt;

  constructor(store, id, screenId, version, name, components, settings, createdAt, updatedAt) {
    this.store = store;
    this.id = id;
    this.screenId = screenId;
    this.version = version;
    this.name = name;
    this.components = components || [];
    this.settings = settings || {};
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  static fromJSON(store, json) {
    const { 
      id, 
      screenId, 
      version, 
      name, 
      data: { components = [], settings = {} } = {}, 
      createdAt, 
      updatedAt 
    } = json;

    // Transform components to include proper mapping
    const transformedComponents = components.map((comp, index) => ({
      id: comp.id || `comp-${index}`,
      componentId: comp.componentId,
      componentName: comp.componentId, // Use componentId as componentName
      displayName: comp.componentName || comp.componentId, // Use componentName as displayName
      props: comp.props || {},
      area: comp.area || "main",
      layout: {
        ...(comp.layout || {}),
        isDraggable: false,
        isResizable: false
      }
    }));

    return new SignageDesign(
      store, 
      id, 
      screenId, 
      version, 
      name, 
      transformedComponents, 
      settings, 
      createdAt, 
      updatedAt
    );
  }

  // Get components by area
  getMainComponents() {
    return this.components.filter(comp => comp.area === "main");
  }

  getSideComponents() {
    return this.components.filter(comp => comp.area === "side");
  }

  getAllComponents() {
    return this.components;
  }

  // Get component count
  getComponentCount() {
    return this.components.length;
  }

  // Check if design has components
  hasComponents() {
    return this.components.length > 0;
  }
}

export default SignageDesign;
